let isPaginationScrollInitialized = false;

const SCROLL_GAP = 12;

// GrapheneHC intercepts pagination link clicks and re-renders the grid in place
// (see the is_paging_request branch in plp.sbnhtml), so the browser never resets
// the scroll position. Scroll to the first row of products rather than the page
// top — shoppers paging through a collection want the next products, not the
// hero and filters again. The grid is replaced in place, so the outgoing page's
// first card marks the same position the incoming one will occupy.
//
// The sticky header's height depends on scroll state (the mobile search row
// hides on scroll-down; the announcement bar can push the header down near the
// page top), so a single click-time measurement can land the card slightly
// under the header. Scroll approximately first, then re-measure the header's
// real bottom edge at the destination and correct the difference.
const initAcsPaginationScroll = () => {
  if (isPaginationScrollInitialized) return;

  // Delegated at document level so it survives ACS replacing the pagination nav.
  document.addEventListener('click', (event) => {
    const linkEl = event.target.closest('[data-acs-pagination] a');
    if (!linkEl) return;

    const firstCardEl = document.querySelector('[data-acs-product-grid] [data-product-card]');
    if (!firstCardEl) {
      window.scrollTo({ top: 0, behavior: 'instant' });
      return;
    }

    const headerEl = document.querySelector('[data-header]');
    const headerHeight = headerEl ? headerEl.getBoundingClientRect().height : 0;
    const targetTop = firstCardEl.getBoundingClientRect().top + window.scrollY - headerHeight - SCROLL_GAP;
    window.scrollTo({ top: Math.max(targetTop, 0), behavior: 'instant' });

    requestAnimationFrame(() => {
      if (!headerEl) return;
      // Re-query rather than closing over firstCardEl: if ACS has already
      // replaced the grid, the old node is detached (rect all zeros — the
      // correction would jump the page up by the header height), and the
      // re-query aligns against the new page's first card instead.
      const currentCardEl = document.querySelector('[data-acs-product-grid] [data-product-card]');
      if (!currentCardEl) return;
      const headerBottom = headerEl.getBoundingClientRect().bottom;
      const cardTop = currentCardEl.getBoundingClientRect().top;
      const correction = cardTop - headerBottom - SCROLL_GAP;
      if (Math.abs(correction) > 1) {
        window.scrollBy({ top: correction, behavior: 'instant' });
      }
    });
  });

  isPaginationScrollInitialized = true;
};

export default initAcsPaginationScroll;
